import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LancerUnProjet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="lancer-un-projet" ref={ref} className={cn("dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40 flex items-center justify-center", "transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(220_15%_12%)_0%,hsl(220_15%_5%)_70%)] pointer-events-none" />
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container relative z-10 px-4 text-center">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight mb-10 text-foreground max-w-4xl mx-auto leading-[1.1]">
          Prêt à transformer votre communication ?
        </h2>
        
        <div className="flex justify-center">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-16 px-10 rounded-full shadow-[0_0_30px_-5px_var(--color-primary)] hover:shadow-[0_0_40px_-5px_var(--color-primary)] transition-all duration-300 border-none">
            <Link to="/ContactPage">
              Démarrer une consultation
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}